var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widM txtC marTX" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "padBX",
        staticStyle: {
          border: "1px solid #3872d3",
          "border-top": "none",
          "border-radius": "0 0 15px 15px"
        }
      },
      [
        _c("span", {
          staticClass: "disIb",
          staticStyle: {
            border: "10px solid transparent",
            "border-top-color": "#3872d3"
          }
        }),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c("p", { staticClass: "colorGray fntP padTM" }, [
          _vm._v(
            "\n      바이옴 특화설계로 지키는 건강한 구강환경 밸런스\n    "
          )
        ]),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "marTML txtL widXS" }, [
          _c("form", [
            _c("div", { staticClass: "row cont_info" }, [
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-8 col last-col" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.aboname,
                      expression: "aboname"
                    }
                  ],
                  staticClass: "form-control",
                  staticStyle: { width: "100%" },
                  attrs: {
                    type: "text",
                    id: "a7070xgli_aboname",
                    name: "a7070xgli_aboname",
                    placeholder: "이름을 입력하여 주세요.",
                    maxlength: "20"
                  },
                  domProps: { value: _vm.aboname },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.aboname = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row padTS cont_info" }, [
              _vm._m(5),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-xs-8 col last-col",
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    "justify-content": "space-between"
                  }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.phone1,
                        expression: "phone1"
                      }
                    ],
                    staticClass: "form-control",
                    staticStyle: { width: "30%" },
                    attrs: {
                      type: "text",
                      id: "a7070xgli_abophone1",
                      name: "a7070xgli_abophone",
                      placeholder: "010",
                      maxlength: "3"
                    },
                    domProps: { value: _vm.phone1 },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.phone1 = $event.target.value
                        },
                        function($event) {
                          return _vm.phoneValid()
                        }
                      ]
                    }
                  }),
                  _vm._v("\n            -\n            "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.phone2,
                        expression: "phone2"
                      }
                    ],
                    staticClass: "form-control",
                    staticStyle: { width: "30%" },
                    attrs: {
                      type: "text",
                      id: "a7070xgli_abophone2",
                      name: "a7070xgli_abophone",
                      placeholder: "0000",
                      maxlength: "4"
                    },
                    domProps: { value: _vm.phone2 },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.phone2 = $event.target.value
                        },
                        function($event) {
                          return _vm.phoneValid()
                        }
                      ]
                    }
                  }),
                  _vm._v("\n            -\n            "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.phone3,
                        expression: "phone3"
                      }
                    ],
                    staticClass: "form-control",
                    staticStyle: { width: "30%" },
                    attrs: {
                      type: "text",
                      id: "a7070xgli_abophone3",
                      name: "a7070xgli_abophone",
                      placeholder: "0000",
                      maxlength: "4"
                    },
                    domProps: { value: _vm.phone3 },
                    on: {
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.phone3 = $event.target.value
                        },
                        function($event) {
                          return _vm.phoneValid()
                        }
                      ]
                    }
                  })
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row padTS cont_info" }, [
              _vm._m(6),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-8 col last-col" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.abonumber,
                      expression: "abonumber"
                    }
                  ],
                  staticClass: "form-control",
                  staticStyle: { width: "100%" },
                  attrs: {
                    type: "text",
                    id: "a7070xgli_abonumber",
                    name: "a7070xgli_abonumber",
                    placeholder: "ABO 번호 또는 소비자 번호",
                    maxlength: "20"
                  },
                  domProps: { value: _vm.abonumber },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.abonumber = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row padTM" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.agree,
                      expression: "agree"
                    }
                  ],
                  attrs: { id: "a7070xgli_agree", type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.agree)
                      ? _vm._i(_vm.agree, null) > -1
                      : _vm.agree
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.agree,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.agree = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.agree = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.agree = $$c
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "normal inline-label checklabel",
                    staticStyle: { margin: "0" },
                    attrs: { for: "a7070xgli_agree" }
                  },
                  [
                    _vm._v(
                      "개인정보 수집, 이용 및 상기 이벤트 내용에 모두 동의합니다."
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row padTX" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c("div", { staticClass: "osResBtnGrp" }, [
                  _c(
                    "button",
                    {
                      staticClass: "osResBtn01",
                      staticStyle: {
                        cursor: "pointer",
                        "background-color": "#00b432",
                        "border-radius": "2em",
                        width: "13em"
                      },
                      style: _vm.joinButtonColor,
                      attrs: { type: "button" },
                      on: { click: _vm.letGoJoin }
                    },
                    [
                      _vm._v(
                        "\n                선착순 이벤트 신청하기\n              "
                      )
                    ]
                  )
                ])
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "fntH4 fntM padTM padBM",
        staticStyle: {
          color: "#fff",
          background: "#3872d3",
          "border-radius": "15px 15px 0 0"
        }
      },
      [_c("strong", [_vm._v("참여하기")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "fntP marTM" }, [
      _vm._v(" 3가지 미션을 모두 완료하면 "),
      _c("br", { staticClass: "moOnly" }),
      _c("em", { staticStyle: { color: "#3872d3" } }, [
        _c(
          "span",
          { staticStyle: { "box-shadow": "inset 0 -10px 0 #fdf729" } },
          [_vm._v("글리스터 프로액션 컴플리트 치약")]
        ),
        _vm._v("(여행용 사이즈)")
      ]),
      _vm._v("를 "),
      _c("br", { staticClass: "moOnly" }),
      _vm._v("선물로 드립니다.\n    ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "marTML" }, [
      _c("img", {
        staticStyle: { "max-width": "690px", width: "100%" },
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/_noticeImg/2023/03/0329_ev_a7070xgli/cont_glister_toothpaste.png",
          alt: "글리스터 프로액션 컴플리트 치약 50 G(여행용 사이즈)"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticClass: "fntH6 padTM", staticStyle: { color: "#3872d3" } },
      [
        _vm._v("\n      글리스터 프로액션 컴플리트 "),
        _c("br", { staticClass: "moOnly" }),
        _vm._v("치약 50 G(여행용 사이즈)\n      증정\n    ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "col-xs-4 control-label",
        attrs: { for: "a7070xgli_aboname" }
      },
      [
        _c(
          "span",
          { staticClass: "regular", staticStyle: { color: "#56565a" } },
          [_vm._v("이름")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "col-xs-4 control-label",
        attrs: { for: "a7070xgli_abophone1" }
      },
      [
        _c(
          "span",
          { staticClass: "regular", staticStyle: { color: "#56565a" } },
          [_vm._v("핸드폰 번호")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "col-xs-4 control-label",
        attrs: { for: "a7070xgli_abonumber" }
      },
      [
        _c(
          "span",
          { staticClass: "regular", staticStyle: { color: "#56565a" } },
          [_vm._v("ABO 번호"), _c("br"), _vm._v("(또는 소비자 번호)")]
        )
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a5697ca", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a5697ca","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/nutrilite/a7070-glister/component/join.vue
// module id = null
// module chunks = 